import { render, staticRenderFns } from "./SaveBtnGroup.vue?vue&type=template&id=3107eff8"
import script from "./SaveBtnGroup.vue?vue&type=script&lang=ts"
export * from "./SaveBtnGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports